import { http } from "../../../shared/api/http";
import { ChatMessage } from "../models/type";

export async function ordersIdMessages(orderId:any): Promise<ChatMessage[]> {
  const res = await http.get(`/restaurant/chat/orders/${orderId}/messages`);
  return res.data;
}